<template>
  <div class="hoist-apply">
    <div class="content" v-loading="loading">
      <!-- 查询栏 -->
      <div class="option-panel">
        <el-form :inline="true" :model="queryParams.params" class="demo-form-inline">
          <el-form-item label="日期">
            <el-date-picker
              style="width: 160px"
              v-model="queryParams.params.currentDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              size="mini"
              :clearable="false"
              @change="onQuery()"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="作业完成状态">
            <el-select
              style="width: 160px"
              v-model="queryParams.params.zyzt"
              placeholder="请选择"
              size="mini"
              @change="onQuery()"
              clearable
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <!-- 任务 -->
      <el-table
        :data="taskData"
        border
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#f6f6f6', color: '#666' }"
      >
        <el-table-column
          v-for="item in taskColumn"
          :fixed="item.fiexd"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
        >
        </el-table-column>
      </el-table>
      <el-divider></el-divider>
      <!-- 作业负责人 -->
      <div class="user-table">
        <el-table
          :data="userData"
          border
          style="width: 100%"
          height="100%"
          :header-cell-style="{ backgroundColor: '#f6f6f6', color: '#666' }"
        >
          <el-table-column
            v-for="item in userColumn"
            :fixed="item.fiexd"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
          background
          size="mini"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          @current-change="currentChange"
          @size-change="sizeChange"
          :current-page="Pagination.currentPage"
          :page-sizes="[10, 15, 30, 50, 100]"
          :page-size="Pagination.pagesize"
          align="center"
          class="pagination"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import * as hoistApplyApi from '../../../api/hoistApply'
import { formatDate } from '../../../util/formatUtil'
export default {
  data() {
    return {
      userColumn: [
        { label: '作业负责人姓名', prop: 'xm' },
        { label: '工号', prop: 'gh' },
        { label: '任务数量', prop: 'task_num' },
        { label: '已完成', prop: 'success' },
        { label: '未完成', prop: 'no_success' },
        { label: '当前状态', prop: 'zyzt' }
      ],
      taskColumn: [
        { label: '任务数量', prop: 'task_num' },
        { label: '已完成', prop: 'success' },
        { label: '今日未完成', prop: 'no_success' },
        { label: '待主管分配任务', prop: 'dzgfprw' },
        { label: '之前未完成', prop: 'old_task_num' }
      ],
      statusOptions: [
        { label: '作业中', value: '作业中' },
        { label: '空闲中', value: '空闲中' }
      ],
      userData: [],
      taskData: [],
      queryParams: {
        page: 1,
        size: 10,
        params: {
          currentDate: this.getDate(),
          wfp: true,
          zyfzr2_order: 'desc'
        }
      },
      totalCount: 0,
      Pagination: {
        currentPage: 1,
        pagesize: 10
      },
      loading: false
    }
  },
  mounted() {
    this.onQuery()
  },
  methods: {
    onQuery(Pagination) {
      let params = JSON.parse(JSON.stringify(this.queryParams))
      if (Pagination) {
        params.page = Pagination.currentPage
        params.size = Pagination.pagesize
      }
      hoistApplyApi.queryTotalData(params).then((res) => {
        this.loading = false
        if (res.success) {
          if (res.data) {
            this.userData = res.data.detailData.data
            this.taskData = res.data.totalData
            this.taskData.forEach(item => {
             if (item.dzgfprw === null) {
                item.dzgfprw = 0
             }
              if(item.no_success === null){
               item.no_success = 0
             }
              if(item.success === null){
               item.success = 0
             }
              if(item.old_task_num === null){
               item.old_task_num = 0
             }
             if(item.task_num === null){
               item.task_num = 0
             }
             item.no_success =  +item.no_success + +item.old_task_num
            })
            this.totalCount = res.data.detailData.total
          }
        } else {
          this.$message.warning('获取作业负责人失败')
        }
      })
    },
    getDate() {
      return formatDate(new Date(), 'yyyy-MM-dd')
    },
    currentChange(currentPage) {
      this.Pagination.currentPage = currentPage
      this.onQuery(this.Pagination)
    },
    sizeChange(pagesize) {
      this.Pagination.pagesize = pagesize
      this.onQuery(this.Pagination)
    }
  }
}
</script>

<style lang="scss" scoped>
.hoist-apply {
  /deep/ .el-table .el-table__cell {
    padding: 4px 0;
  }
  .content {
    padding: 14px;
  }
  .user-table {
    height: calc(100vh - 400px);
    padding-bottom: 10px;
  }
  .pagination{
    padding-bottom: 20px;
  }
}
</style>
